import {
  NOTIFICATION_TYPES,
  DRAWER_PLACEMENTS,
} from "../../../../../config/constants";
import {
  Empty,
  Select,
  Button,
  Form,
  Input,
  InputNumber,
  Drawer,
  Space,
  AutoComplete,
  Pagination,
  Collapse,
  Popconfirm, Modal, Checkbox,
  Switch, Tooltip
} from "antd";
import "./ValidationMapping.css";
import {
  CheckOutlined,
  EditOutlined,
  CloseOutlined,
  ExperimentOutlined,
  ForwardOutlined,
  CopyOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import Datatable from "../../../../shared/components/Datatable";
import { GetTablesRequest } from "../../../../../models/tables/GetTablesRequest";
import TablesService from "../../../../../services/tables/TablesService";
import FieldMappingsService from "../../../../../services/fieldmappings/FieldMappingsService";
import { GetFieldMappingsRequest } from "../../../../../models/fieldmappings/GetFieldMappingsRequest";
import { useTranslation } from "react-i18next";
import { ColumnsType } from "antd/lib/table";
import NotificationsUtil from "../../../../shared/utils/NotificationsUtil";
import GroupCodesService from "../../../../../services/groupcodes/GroupCodesService";
import { TestFieldMappingRequest } from "../../../../../models/fieldmappings/TestFieldMappingRequest";
import styles from "./ValidationMapping.module.css";
import TextArea from "antd/lib/input/TextArea";
import history from "../../../../shared/utils/HistoryUtil";
import EnvironmentService from "../../../../../services/environments/EnvironmentService";
import {useDispatch, useSelector} from "react-redux";
import LabelUtil from "../../../../shared/utils/LabelUtil";
import { GetFieldsRequest } from "../../../../../models/fields/GetFieldsRequest";
import ApplicationService from "../../../../../services/application/ApplicationService";
import { TABLE_SETUP_HIDE_SYSTEM_FIELDS } from "../../../../../config/consts/appsettings";
import {setTestEnvironment} from "../../../../../redux/actions";

const { Panel } = Collapse;

const ValidationMapping = ({
  entities,
  selectedGroupCode,
  selectedEntity,
  setAutomapValidationMappingModalEnabled,
  automapValidationMappingModalEnabled,
}: {
  entities: any;
  selectedGroupCode: any;
  selectedEntity: any;
  setAutomapValidationMappingModalEnabled: (val: boolean) => void;
  automapValidationMappingModalEnabled: boolean;
}) => {
  const dispatch = useDispatch();
  
  const { t, i18n } = useTranslation("translations");

  enum RowAction {
    View = 1,
    Edit,
    Create,
  }

  const [showUnmappedOnly, setShowUnmappedOnly] = useState<boolean>(false);
  const [showMandatoryOnly, setShowMandatoryOnly] = useState<boolean>(false);
  const [showSystemFields, setShowSystemFields] = useState<boolean>(false);

  const { testEnvironment } = useSelector((state: any) => ({ testEnvironment: state.testEnvironment }));

  const [data, setData] = useState<any>([]);
  const [tempData, setTempData] = useState<any>([]);
  const [drawerForm] = Form.useForm();

  const [drawerAction, setDrawerAction] = useState<RowAction>();
  const [drawerTitle, setDrawerTitle] = useState<string>("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editedRow, setEditedRow] = useState<any>();
  const [originalEditedRow, setOriginalEditedRow] = useState<any>();
  const [testRow, setTestRow] = useState<any>();
  const [loadingButton, setLoadingButton] = useState(false);

  const [updateValidationMappingDisabled, setUpdateValidationMappingDisabled] =
    useState(false);
  const [createValidationMappingDisabled, setCreateValidationMappingDisabled] =
    useState(false);

  const [selectedDestinationTable, setSelectedDestinationTable] =
    useState<any>(null);

  const [fromTables, setFromTables] = useState<any>();
  const [fromTablesWithFields, setFromTablesWithFields] = useState<any>(null);
  const [fieldMappings, setFieldMappings] = useState<any>(null);

  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);

  const [refreshTriggered, setRefreshTriggered] = useState<boolean>(false);
  const [openTestDrawer, setOpenTestDrawer] = useState(false);
  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [isTestTableLoading, setIsTestTableLoading] = useState<boolean>(false);

  const [viewTablePageIndex, setViewTablePageIndex] = useState(1);
  const [viewTablePageSize, setViewTablePageSize] = useState(10);

  const [testTableViewData, setTestTableViewData] = useState<any>([]);
  const [testTableColumns, setTestTableColumns] = useState<
    ColumnsType<DataType>
  >([]);
  const [selectedTestGroupCode, setSelectedTestGroupCode] = useState<any>();

  const [isDirty, setIsDirty] = useState<any>(false);
  const [environment, setEnvironments] = useState<any>([]);
  const [selectedEnvironment, setSelectedEnvironment] = useState<any>();

  const [attributes, setAttributes] = useState<string[]>([]);
  const [selectedAttribute, setSelectedAttribute] = useState<string>("");

  const [groupCodeMandatory, setGroupCodeMandatory] = useState<any>();

  const [testForm] = Form.useForm();
  const [translationForm] = Form.useForm();

  const { userPermissions } = useSelector((state: any) => ({
    userPermissions: state.userPermissions,
  }));

  const [popConfirmOpen, setPopConfirmOpen] = useState<boolean>(false);

  const [automapGroupCodeInput, setAutomapGroupCodeInput] = useState<string>("");
  const [automapEntityInput, setAutomapEntityInput] = useState<string>("");
  const [automapOverwriteExistingData, setAutomapOverwriteExistingData] = useState<boolean>(true);

  const [translationModal, setTranslationModal] = useState<boolean>(false);

  const [fromValue, setFromValue] = useState<string>("");

  const getPermissionsFunction = (record: any) => {
    return userPermissions.find(p => p.groupCodeName === (record.groupCode ?? null) && p.entityId === selectedEntity);
  }

  useEffect(() => {
    if (!isDirty) return;

    const unblock = history.block((tx: any) => {
      if (
        window.confirm(
          "Are you sure you want leave the page without saving? Current changes will be lost."
        )
      ) {
        unblock();
        tx.retry();
      }
    });

    return () => {
      unblock();
    };
  }, [isDirty]);

  useEffect(() => {
    if (editedRow && originalEditedRow) {
      if (updateValidationMappingDisabled) {
        setIsDirty(false);
      } else {
        setIsDirty(true);
      }
    } else {
      setIsDirty(false);
    }
  }, [editedRow, originalEditedRow, updateValidationMappingDisabled]);

  useEffect(() => {
    EnvironmentService.getAll().then((response: any) => {
      const data = response.data;
      setEnvironments(data);
    });

    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });

    ApplicationService.getPreferences().then((response: any) => {
      var hideSystemFieldsPreference = response.data.find(
        (p) =>
          p.key === TABLE_SETUP_HIDE_SYSTEM_FIELDS &&
          p.object === "Application"
      );
      if (hideSystemFieldsPreference) {
        setShowSystemFields(hideSystemFieldsPreference.value !== "true");
      }
    });
  }, []);

  useEffect(() => {
    if (selectedEntity) {
      setFieldMappings(null);
      setFromTablesWithFields(null);
      setTempData([]);
      setData([]);
      setIsTableLoading(true);
      const model: GetTablesRequest = {
        entityId: selectedEntity,
        operationId: 3,
        groupCode: "",
      };

      TablesService.getTables(model).then((response: any) => {
        if (!response.data[0]) {
          setIsTableLoading(false);
        }
        setSelectedDestinationTable(response.data[0]?.id);
        setRefreshTriggered(!refreshTriggered);
      });

      const tablesWithFieldsModel = {
        groupCode: "",
        entityId: selectedEntity,
        operationId: -1,
      };

      TablesService.getAllFromTablesWithFields(tablesWithFieldsModel).then(
        (response: any) => {
          setFromTablesWithFields(response.data);
        }
      );
    }
  }, [selectedEntity, selectedGroupCode]);

  useEffect(() => {
    if (selectedDestinationTable) {
      setIsTableLoading(true);
      const model: GetFieldMappingsRequest = {
        groupCode: selectedGroupCode ?? "",
        toTableId: selectedDestinationTable,
        fromTableId: -1,
      };
      const fieldsModel: GetFieldsRequest = {
        tableId: selectedDestinationTable
      };

      TablesService.getFields(fieldsModel).then((fieldsResponse: any) => {
        FieldMappingsService.getAll(model).then((response: any) => {
          setFieldMappings(
            response.data.map((x: any) => ({
              ...x,
              fromValue: x.fromValue === null ? "" : x.fromValue,
              comments: x.comments === null ? "" : x.comments,
              fromField: x.fromField === null ? "" : x.fromField,
              mandatory: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.isMandatory,
              label: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.label,
              description: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.description,
              groupCode: x.isInherited ? null : selectedGroupCode,
              color: selectedGroupCode !== null && selectedGroupCode !== undefined && x.isInherited ? "highlight-inherited-row" : "",
              deleteAllowed: selectedGroupCode !== null && selectedGroupCode !== undefined && !x.isInherited,
              copyAllowed: true,
            }))
          );
        });
      });

      TablesService.getAllToTableFields(selectedDestinationTable).then(
        (response: any) => {
          setTempData(
            response.data.filter((field: any) => !field.isSystemField || showSystemFields).map((field: any) => ({
              groupCode: null,
              fromTable: "",
              fromField: "",
              toTableId: field.tableId,
              toField: field.name,
              toFieldId: field.id,
              label: field.label,
              description: field.description,
              fromTableId: null,
              fromFieldList: [],
              fromFieldId: null,
              fromValue: "",
              mappingId: "",
              isSystemField: field.isSystemField,
              join: "",
              comments: "",
              sequence: null,
            }))
          );
        }
      );
    } else {
      setTempData([]);
      setFieldMappings(null);
      setFromTablesWithFields(null);
      setIsTableLoading(false);
    }
  }, [selectedDestinationTable, refreshTriggered, showSystemFields]);

  useEffect(() => {
    if (tempData && fieldMappings && fromTablesWithFields) {
      if (
        tempData.length > 0 &&
        fieldMappings.length > 0 &&
        fromTablesWithFields.length > 0
      ) {
        let newData: any = [];

        tempData.forEach((row: any) => {
          let res = row;
          const fieldMapping = fieldMappings
            // .find((m:any) => m.toFieldId === res.toFieldId && (m.fromFieldId !== null || m.fromValue !== ''));
            .find((m: any) => m.toFieldId === res.toFieldId);
          if (
            fieldMapping &&
            fieldMapping !== undefined &&
            fieldMapping !== null
          ) {
            res.fromTableId = fieldMapping.fromTableId;
            if (res.fromTableId !== null) {
              res.fromFieldList = fromTablesWithFields
                .find((table: any) => table.id === res.fromTableId)
                ?.fields.map((field: any) => ({
                  nameLabel: field.label ? field.name + " | " + field.label : field.name,
                  label: field.name,
                  value: field.id,
                }));
            }
            res.fromFieldId = fieldMapping.fromFieldId;
            res.fromValue =
              res.fromFieldId === null
                ? fieldMapping.fromValue === null
                  ? ""
                  : fieldMapping.fromValue
                : fieldMapping.fromField;
            res.fromField =
              res.fromFieldId === null
                ? fieldMapping.fromValue === null
                  ? ""
                  : fieldMapping.fromValue
                : fieldMapping.fromField;
            res.groupCode = fieldMapping.groupCode;
            res.fromTable = fieldMapping?.fromTable?.split(".")[2];
            res.mappingId = fieldMapping.id;
            res.id = fieldMapping.id;
            res.join = fieldMapping.link;
            res.label = fieldMapping.label;
            res.description = fieldMapping.description;
            res.comments = fieldMapping.comments;
            res.customFields = fieldMapping.customFields;
            res.where = fieldMapping.where;
            res.sequence = fieldMapping.sequence;
            res.color = fieldMapping.color;
            res.deleteAllowed = fieldMapping.deleteAllowed;
            res.copyAllowed = fieldMapping.copyAllowed;
            res.position = fieldMapping.toPosition;
            res.mandatory = fieldMapping.mandatory;
            res.isInherited = fieldMapping.isInherited;
            res.globalMappingId = fieldMapping.globalMappingID;
          }

          newData.push(res);
        });
        setData([...newData.map((x: any) => x)]);
        setIsTableLoading(false);
      } else {
        setIsTableLoading(false);
        setData([]);
      }
    }
  }, [tempData, fieldMappings, fromTablesWithFields]);

  useEffect(() => {
    if (fromTablesWithFields) {
      setFromTables(
        fromTablesWithFields
          .filter(
            (table: any) => table.operationId === 2 || table.operationId === 4
          )
          .map((table: any) => ({
            label: table.name.split(".")[2],
            value: table.id,
          }))
      );
    }
  }, [fromTablesWithFields]);

  useEffect(() => {
    if (automapValidationMappingModalEnabled) {
      if (selectedGroupCode) {
        setAutomapGroupCodeInput(selectedGroupCode);
      }
      if (selectedEntity) {
        setAutomapEntityInput(selectedEntity);
      }
      setAutomapOverwriteExistingData(true);
    }
  }, [automapValidationMappingModalEnabled]);

  const showDrawer = (action: RowAction, fieldName: string = "", label: string = "") => {
    setDrawerAction(action);
    switch (action) {
      case RowAction.View:
        setDrawerTitle(
          t(
            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.RowDetails",
            {
              lngs: i18n.languages,
              defaultValue: "Row details",
            }
          )!
        );
        break;
      case RowAction.Create:
        setDrawerTitle(
          t(
            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.NewValidationMapping",
            {
              lngs: i18n.languages,
              defaultValue: "New validation mapping",
            }
          )!
        );
        break;
      case RowAction.Edit:
        setDrawerTitle(
          t(
            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.EditValidationMapping",
            {
              lngs: i18n.languages,
              defaultValue: "Edit validation mapping",
            }
          )! + ' - ' + fieldName + (label ? ` | ${label}` : '')
        );
        break;
      default:
        break;
    }
    setOpenDrawer(true);
  };

  const onShowTestDrawer = () => {
    setOpenTestDrawer(true);
  };

  useEffect(() => {
    if (editedRow) {
      setTestRow({
        entity: entities.find((x: any) => x.id === selectedEntity)?.name,
        groupCode: selectedGroupCode,
        environment: testEnvironment,
        fromFieldId: editedRow?.fromFieldId,
        fromValue: editedRow?.fromValue,
        join: editedRow?.join,
        customFields: editedRow?.customFields,
        where: editedRow?.where,
        sqlCode: "",
      });
      
      setSelectedEnvironment(testEnvironment);
      setSelectedTestGroupCode(selectedGroupCode);

      TablesService.getTranslationAtrributes(editedRow.groupCode).then((response: any) => {
        setAttributes(response.data);
      });
    }
  }, [editedRow]);

  useEffect(() => {
    if (editedRow) {
      if (groupCodeMandatory && !editedRow.groupCode) {
        setCreateValidationMappingDisabled(true);
      } else {
        setCreateValidationMappingDisabled(false);
      }
    }
  }, [editedRow, originalEditedRow]);

  useEffect(() => {
    if (editedRow && originalEditedRow) {
      const current = JSON.stringify(editedRow);
      const def = JSON.stringify(originalEditedRow);

      if (current !== def) {
        setUpdateValidationMappingDisabled(false);
      } else {
        setUpdateValidationMappingDisabled(true);
      }
    } else {
      setUpdateValidationMappingDisabled(false);
    }
  }, [editedRow, originalEditedRow]);

  useEffect(() => {
    if (!openDrawer) {
      setGroupCodeMandatory(false);
    }
  }, [openDrawer])

  useEffect(() => {
    if (openTestDrawer) {
      runTest(true);
    }
  }, [openTestDrawer]);

  const onClose = () => {
    setOpenDrawer(false);
    setEditedRow(null);
    setOriginalEditedRow(null);
    setTestRow(null);
    setTranslationModal(false);
    setFromValue("");
    setSelectedAttribute("");
    clearTranslationForm();
  };

  const clearTranslationForm = () => {
    setSelectedAttribute("");
    setSelectedAttribute("");
  }

  const onCloseTestDrawer = () => {
    setTestTableViewData([]);
    setTestTableColumns([]);
    setTestRow({ ...testRow, sqlCode: "" });
    setOpenTestDrawer(false);
  };

  const onTestApplyChanges = () => {
    setEditedRow({
      ...editedRow,
      fromValue: testRow?.fromValue,
      join: testRow?.join,
      customFields: testRow?.customFields,
      where: testRow?.where,
    });
    setOpenTestDrawer(false);
  };

  const onEditValidationMapping = (record: any) => {
    showDrawer(RowAction.Edit, record.toField, record.label);
    setEditedRow({
      ...record,
      editableGroupCode: false,
    });
    setOriginalEditedRow({
      ...record,
      editableGroupCode: false,
    });
  };

  const onCopyValidationMapping = (record: any) => {
    showDrawer(RowAction.Create);

    if (record.id !== null) {
      setGroupCodeMandatory(true);
    }

    setEditedRow({
      ...record,
      groupCode: record.id !== null ? null : selectedGroupCode,
      id: null,
      mappingId: null,
      editableGroupCode: true,
    });
    setOriginalEditedRow({
      ...record,
      groupCode: selectedGroupCode,
      editableGroupCode: true,
    });
  };

  const onAutomapValidationMapping = () => {
    const entity = entities.find(x => x.id === automapEntityInput)?.name;
    if (entity) {
      setLoadingButton(true);
      const model = {
        groupCode: automapGroupCodeInput,
        entity: entity,
        overwrite: automapOverwriteExistingData,
      };

      FieldMappingsService.automap(model)
        .then((response: any) => {
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Operation.ValidationRules.Tabs.ValidationMapping.Notifications.ValidationMapping.AutomapSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Validation mapping automapped successfully.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          setRefreshTriggered(!refreshTriggered);
          setAutomapValidationMappingModalEnabled(false);
          setIsDirty(false);
        })
        .catch((error: any) => {
          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        })
        .finally(() => {
          setLoadingButton(false);
        });
    }
  };

  const onSaveNewValidationMapping = () => {
    if (editedRow) {
      setLoadingButton(true);
      const found = editedRow?.fromFieldList?.find(
        (x: any) => x.label.toLowerCase() === editedRow?.fromValue.toLowerCase()
      );
      const model = {
        id: editedRow.groupCode ? editedRow.mappingId : editedRow.globalMappingId,
        mappingId: editedRow.groupCode ? editedRow.mappingId : editedRow.globalMappingId,
        fromTableId: editedRow.fromTableId,
        // FromTableId: mapping.fromTableId !== '' ? mapping.fromTableId : null,
        fromFieldId: found ? found.value : null,
        fromValue: found ? "" : editedRow.fromValue,
        toTableId: editedRow.toTableId,
        toFieldId: editedRow.toFieldId,
        link: editedRow.join,
        customFields: editedRow.customFields,
        where: editedRow.where,
        comments: editedRow.comments,
        sequence: editedRow.sequence,
        groupCode: editedRow.groupCode ?? "",
      };

      if (model.mappingId) {
        FieldMappingsService.update(model)
          .then((response: any) => {
            NotificationsUtil.openNotificationDialog({
              description: t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Notifications.ValidationMapping.SaveSuccessDescription",
                {
                  lngs: i18n.languages,
                  defaultValue: "Validation mapping saved successfully.",
                }
              )!,
              type: NOTIFICATION_TYPES.SUCCESS,
              logError: false,
            });
            setRefreshTriggered(!refreshTriggered);
            setOpenDrawer(false);
            setIsDirty(false);
          })
          .catch((error: any) => {
            NotificationsUtil.openNotificationDialog({
              description: error.response.data,
              type: NOTIFICATION_TYPES.ERROR,
              logError: true,
            });
          })
          .finally(() => {
            setLoadingButton(false);
          });
      } else {
        FieldMappingsService.create(model)
          .then((response: any) => {
            NotificationsUtil.openNotificationDialog({
              description: t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Notifications.ValidationMapping.SaveSuccessDescription",
                {
                  lngs: i18n.languages,
                  defaultValue: "Validation mapping saved successfully.",
                }
              )!,
              type: NOTIFICATION_TYPES.SUCCESS,
              logError: true,
            });
            setRefreshTriggered(!refreshTriggered);
            setOpenDrawer(false);
            setIsDirty(false);
          })
          .catch((error: any) => {
            NotificationsUtil.openNotificationDialog({
              description: error.response.data,
              type: NOTIFICATION_TYPES.ERROR,
              logError: true,
            });
          })
          .finally(() => {
            setLoadingButton(false);
          });;
      }
    }
  };

  const translationModalOnOk = () => {
    setEditedRow({
      ...editedRow,
      join: `LEFT JOIN [Mapping].[Translation] tr ON tr.GroupCode ${editedRow.groupCode ? `= '${editedRow.groupCode}'` : 'IS NULL'} AND tr.Attribute = '${selectedAttribute}' AND tr.FromValue = stbl.[${fromValue}]`,
      fromValue: "tr.ToValue",
    }); 

    setFromValue("");
    setSelectedAttribute("");
    translationForm.setFieldsValue({
      fromValue: "",
      attribute: "",
    })
    setTranslationModal(false);
  }

  const onDeleteValidationMapping = (id: number) => {
    const model = {
      id: id,
    };

    FieldMappingsService.remove(model)
      .then((response: any) => {
        NotificationsUtil.openNotificationDialog({
          description: t(
            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Notifications.ValidationMapping.DeleteSuccessDescription",
            {
              lngs: i18n.languages,
              defaultValue: "Validation mapping deleted successfully.",
            }
          )!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });
        setRefreshTriggered(!refreshTriggered);
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
      });
  };

  const addNewLineOnJoins = (sqlCode: string) => {
    const joinStatements = ['INNER JOIN', 'LEFT JOIN', 'LEFT OUTER JOIN', 'FULL OUTER JOIN'];
    joinStatements.forEach(joinStatement => {
      sqlCode = sqlCode.replaceAll(joinStatement, `\n${joinStatement}`)
    });

    return sqlCode;
  }

  const handleOpenPopConfirm = (newOpen: boolean) => {
    if (!newOpen) {
      setPopConfirmOpen(newOpen);
      return;
    }
    if (!isDirty) {
      onClose();
    } else {
      setPopConfirmOpen(newOpen);
    }
  }

  const runTest = (generateOnlySQLQuery: boolean) => {
    if (!generateOnlySQLQuery) {
      setIsTestTableLoading(true);  
    }
    
    const model: TestFieldMappingRequest = {
      entity: testRow?.entity,
      // groupCode: testRow.groupCode,
      // fromField: testRow.fromField,
      groupCode: selectedTestGroupCode,
      environment: selectedEnvironment,
      fromField: testRow?.fromValue
        ? testRow?.fromValue.replaceAll("\n", " ")
        : "",
      customFields: testRow?.customFields
        ? testRow?.customFields.replaceAll("\n", " ")
        : "",
      join: testRow?.join ? testRow?.join.replaceAll("\n", " ") : "",
      where: testRow?.where ? testRow?.where.replaceAll("\n", " ") : "",
      sqlCode: testRow?.sqlCode,
      fetchOnlySQLQuery: generateOnlySQLQuery,
    };
    FieldMappingsService.test(model)
      .then((response: any) => {
        const styledSqlCode = addNewLineOnJoins(response.data.sqlCode);
        setTestRow({ ...testRow, sqlCode: styledSqlCode });

        if (response.data.data.length > 0) {
          const columnKeys = Object.keys(response.data.data[0]);
          setTestTableColumns(
            columnKeys.map((item: any) => ({
              title: item,
              dataIndex: item,
              key: item,
              width: 200,
              filters: [],
              fitlerMode: "tree",
              filterSearch: true,
              ellipsis: true,
            }))
          );
        }
        setTestTableViewData(response.data.data);
        // NotificationsUtil.openNotificationDialog({
        //   description: t(
        //     "Page.Operation.ValidationRules.Tabs.ValidationMapping.Notifications.ValidationMappingTest.RunSuccessDescription",
        //     {
        //       lngs: i18n.languages,
        //       defaultValue: "Query has executed successfully.",
        //     }
        //   )!,
        //   type: NOTIFICATION_TYPES.SUCCESS,
        // });
        setIsTestTableLoading(false);
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
        setIsTestTableLoading(false);
      });
  };

  useEffect(() => {
    if (testRow) {
      testForm.setFieldsValue({
        fromValue: testRow.fromValue,
        fromField: testRow.fromField,
        customFields: testRow.customFields,
        join: testRow.join,
        where: testRow.where
      });
    } else {
      testForm.setFieldsValue({
        fromValue: "",
        fromField: "",
        customFields: "",
        join: "",
        where: ""
      });
    }
  }, [testRow]);

  const onGroupCodeChange = (value: string) => {
    setEditedRow({
      ...editedRow,
      groupCode: value,
    })
  };

  const onSelectedFromTableChange = (value: string) => {
    setEditedRow({
      ...editedRow,
      fromTableId: value,
      fromFieldList: fromTablesWithFields
        .find((table: any) => table.id === value)
        ?.fields.map((field: any) => ({
          label: field.label ? field.name + " | " + field.label : field.name,
          value: field.id,
        })),
    });
  };

  const onAreaSelectedFromFieldChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    const found = editedRow?.fromFieldList?.find(
      (x: any) => x.label.toLowerCase() === event.target.value?.toLowerCase()
    );
    setEditedRow({
      ...editedRow,
      fromValue: found ? found.label : event.target.value,
    });
  };

  const onAutoCompleteSelectedFromFieldChange = (value: string) => {
    const found = editedRow?.fromFieldList?.find(
      (x: any) => x.label.toLowerCase() === value?.toLowerCase()
    );
    setEditedRow({ ...editedRow, fromValue: found ? found.label : value });
  };

  // const onSelectedFromFieldChange = (value: string) => {
  //   const found = editedRow?.fromFieldList?.find(
  //     (x: any) => x.label.toLowerCase() === value?.toLowerCase()
  //   );
  //   setEditedRow({ ...editedRow, fromValue: found ? found.label : value });
  // };

  const onSelectedJoinChange: React.ChangeEventHandler<HTMLTextAreaElement> = (
    event
  ) => {
    setEditedRow({ ...editedRow, join: event.target.value });
  };

  const onSelectedCommentsChange: React.ChangeEventHandler<HTMLTextAreaElement> = (
    event
  ) => {
    setEditedRow({ ...editedRow, comments: event.target.value });
  };

  const onSelectedSequenceChange = (value: number) => {
    setEditedRow({ ...editedRow, sequence: value });
  };

  const onTestGroupCodeChange = (value: string) => {
    setSelectedTestGroupCode(value);
  };

  const onEnvironmentChange = (value: string) => {
    setSelectedEnvironment(value);
    dispatch(setTestEnvironment(value));
  };

  const onAreaSelectedTestFromFieldChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    const found = editedRow?.fromFieldList?.find(
      (x: any) => x.label.toLowerCase() === event.target.value?.toLowerCase()
    );
    setTestRow({
      ...testRow,
      fromValue: found ? found.label : event.target.value,
    });
    testForm.setFieldsValue({
      fromValue: found ? found.label : event.target.value,
    });
  };

  const onAutoCompleteSelectedTestFromFieldChange = (value: string) => {
    const found = editedRow?.fromFieldList?.find(
      (x: any) => x.label.toLowerCase() === value?.toLowerCase()
    );
    setTestRow({ ...testRow, fromValue: found ? found.label : value });
    testForm.setFieldsValue({
      fromValue: found ? found.label : value,
    });
  };

  const onSelectedTestCustomFieldsChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, customFields: event.target.value });
  };

  const onSelectedTestJoinChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, join: event.target.value });
  };

  const onSelectedTestWhereChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, where: event.target.value });
  };
  const onAutomapGroupCodeChange = (value: string) => {
    setAutomapGroupCodeInput(value);
  };

  const onAutomapEntityChange = (value: string) => {
    setAutomapEntityInput(value);
  };

  const getValidationMappingData = () => {
    let res = data.map((x: any) => { return { ...x } });

    if (showUnmappedOnly) {
      res = res.filter(
        (el: any) => selectedGroupCode !== null && selectedGroupCode !== undefined && el.isInherited
      )
    }

    if (showMandatoryOnly) {
      res = res.filter(
        (el: any) => el.mandatory
      )
    }

    return res
  }

  const tableColumns = [
    {
      key: "groupCode",
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationMapping.Table.Headers.GroupCode",
        {
          lngs: i18n.languages,
          defaultValue: "Groupcode",
        }
      ),
      editable: true,
      width: "150px",
      sorter: (a: any, b: any) => a.groupCode ? a.groupCode.localeCompare(b.groupCode ?? "") : "".localeCompare(b.groupCode ?? ""),
    },
    {
      key: "fromTable",
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationMapping.Table.Headers.FromTable",
        {
          lngs: i18n.languages,
          defaultValue: "From table",
        }
      ),
      editable: true,
      width: "150px",
      sorter: (a: any, b: any) => a.fromTable ? a.fromTable.trim().localeCompare(b.fromTable ? b.fromTable.trim() : "") : "".localeCompare(b.fromTable ? b.fromTable.trim() : ""),
    },
    {
      key: "fromField",
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationMapping.Table.Headers.FromField",
        {
          lngs: i18n.languages,
          defaultValue: "From field",
        }
      ),
      editable: true,
      ellipsis: true,
      sorter: (a: any, b: any) => a.fromField ? a.fromField.trim().localeCompare(b.fromField ? b.fromField.trim() : "") : "".localeCompare(b.fromField ? b.fromField.trim() : ""),
    },
    {
      key: "toField",
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationMapping.Table.Headers.ToField",
        {
          lngs: i18n.languages,
          defaultValue: "To field",
        }
      ),
      editable: false,
      ellipsis: true,
      sorter: (a: any, b: any) => a.toField ? a.toField.trim().localeCompare(b.toField ? b.toField.trim() : "") : "".localeCompare(b.toField ? b.toField.trim() : ""),
      render: (text, row: any) => {
        if (row.mandatory) {
          return (
              <Tooltip
                  placement="right"
                  title={row.description}
              >
                <span className={styles.tableRowFieldRequired}>{row.label ? row.toField + " | " + row.label : row.toField}</span>
              </Tooltip>)
        } else {
          return (<Tooltip  
              placement="right"
              title={row.description}
          >
            <span>{row.label ? row.toField + " | " + row.label : row.toField}</span>
          </Tooltip>)
          }
      },
    },
    {
      key: "join",
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationMapping.Table.Headers.Join",
        {
          lngs: i18n.languages,
          defaultValue: "Join",
        }
      ),
      editable: true,
      ellipsis: true,
      sorter: (a: any, b: any) => a.join ? a.join.trim().localeCompare(b.join ? b.join.trim() : "") : "".localeCompare(b.join ? b.join.trim() : ""),
    },
    {
      key: "comments",
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationMapping.Table.Headers.Comments",
        {
          lngs: i18n.languages,
          defaultValue: "Comments",
        }
      ),
      editable: true,
      ellipsis: true,
      sorter: (a: any, b: any) => a.comments ? a.comments.trim().localeCompare(b.comments ? b.comments.trim() : "") : "".localeCompare(b.comments ? b.comments.trim() : ""),
    },
    {
      key: "sequence",
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationMapping.Table.Headers.Sequence",
        {
          lngs: i18n.languages,
          defaultValue: "Sequence",
        }
      ),
      editable: true,
      width: "110px",
      sorter: (a: any, b: any) => (a.sequence != null ? a.sequence : Infinity) - (b.sequence != null ? b.sequence : Infinity),
    },
  ];

  const scroll = { y: "calc(100vh - 360px)" };

  interface DataType {
    key: string;
    fromValue: string;
    toValue: string;
  }

  return (
    <div id="validation-mapping-table" className="validation-mapping-tab-container">
      {!selectedEntity ? (
        <Empty
          style={{ display: "flex", width: "100%" }}
          description={t(
            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tutorial.GetStarted",
            {
              lngs: i18n.languages,
              defaultValue: "Please select an Entity to get started",
            }
          )}
        ></Empty>
      ) : (
        <div className="validation-mapping-data-container">
          <div className="title-actions" style={{ justifyContent: "end" }}>
            <div className="action-buttons">
              <Checkbox
                checked={showMandatoryOnly}
                onClick={() => setShowMandatoryOnly(!showMandatoryOnly)}
              >
                {t(
                  "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ShowMandatoryOnly",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Show mandatory only",
                  }
                )}
              </Checkbox>
              <Checkbox
                checked={showUnmappedOnly}
                onClick={() => setShowUnmappedOnly(!showUnmappedOnly)}
              >
                {t(
                  "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ShowUnmappedOnly",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Show unmapped only",
                  }
                )}
              </Checkbox>
              <Checkbox
                checked={showSystemFields}
                onClick={() => setShowSystemFields(!showSystemFields)}
              >
                {t(
                  "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ShowSystemFields",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Show system fields",
                  }
                )}
              </Checkbox>
            </div>
          </div>
          <div className="validation-mapping-table-container">
            <Datatable
              scroll={scroll}
              tableColumns={tableColumns}
              data={getValidationMappingData()}
              setData={setData}
              isTableLoading={isTableLoading}
              otherActions={[]}
              otherRowEnabled={false}
              editRowEnabled={true}
              copyRowEnabled={false}
              deleteRowEnabled={false}
              onEditFunc={onEditValidationMapping}
              onCopyFunc={onCopyValidationMapping}
              onDeleteFunc={onDeleteValidationMapping}
              onDoubleClickRow={undefined}
              selectable={false}
              multiSelect={false}
              selectedRows={[]}
              setSelectedRows={undefined}
              checkPermissions={true}
              getPermissionsFunction={getPermissionsFunction}
              paginationDisabled={true}
            ></Datatable>
          </div>
        </div>
      )
      }
      {openDrawer && (
        <Drawer
          width={"400px"}
          getContainer={false}
          style={{ position: "absolute" }}
          title={drawerTitle}
          placement={DRAWER_PLACEMENTS.BOTTOM}
          onClose={onClose}
          visible={openDrawer}
          closable={false}
          height={"500px"}
          extra={
            <Space>
              {RowAction?.View === drawerAction && (
                <>
                  <Button
                    onClick={() => showDrawer(RowAction.Edit)}
                    icon={<EditOutlined />}
                    className={"active-btn"}
                    size="small"
                  >
                    {t("General.Labels.Edit", {
                      lngs: i18n.languages,
                      defaultValue: "Edit",
                    })}
                  </Button>
                  <Button
                    type="ghost"
                    onClick={onClose}
                    icon={<CloseOutlined />}
                    size="small"
                  />
                </>
              )}
              {RowAction?.Edit === drawerAction && (
                <>
                  <Button
                    // disabled={!updateRowAllowed}
                    // className={!updateRowAllowed ? "" : "active-btn"}
                    onClick={onShowTestDrawer}
                    icon={<ExperimentOutlined />}
                    size="small"
                    loading={loadingButton}
                  >
                    {t(
                      "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ActionTest",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Test",
                      }
                    )}
                  </Button>
                  <Button
                    disabled={updateValidationMappingDisabled}
                    // className={!updateRowAllowed ? "" : "active-btn"}
                    onClick={onSaveNewValidationMapping}
                    icon={<CheckOutlined />}
                    size="small"
                    loading={loadingButton}
                  >
                    {t("General.Labels.Update", {
                      lngs: i18n.languages,
                      defaultValue: "Update",
                    })}
                  </Button>
                  <Popconfirm
                    style={{ width: "400px" }}
                    placement="topRight"
                    title={
                      <div
                        style={{
                          width: "400px",
                          wordBreak: "break-word",
                        }}
                      >
                        {t(
                          "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ConfirmClose",
                          {
                            lngs: i18n.languages,
                            defaultValue:
                              "Are you really sure that you want to close this drawer? All changes made will be lost.",
                          }
                        )}
                      </div>
                    }
                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                    visible={popConfirmOpen}
                    onVisibleChange={handleOpenPopConfirm}
                    onConfirm={() => onClose()}
                    // onCancel={() => cancel}
                    okText={t("General.Actions.Yes", {
                      lngs: i18n.languages,
                      defaultValue: "Yes",
                    })}
                    cancelText={t("General.Actions.No", {
                      lngs: i18n.languages,
                      defaultValue: "No",
                    })}
                  >
                    <Button
                      type="ghost"
                      icon={<CloseOutlined />}
                      size="small"
                    />
                  </Popconfirm>
                </>
              )}
              {RowAction?.Create === drawerAction && (
                <>
                  <Button
                    onClick={onShowTestDrawer}
                    icon={<ExperimentOutlined />}
                    size="small"
                    loading={loadingButton}
                  >
                    {t(
                      "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ActionTest",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Test",
                      }
                    )}
                  </Button>
                  <Button
                    disabled={createValidationMappingDisabled}
                    onClick={onSaveNewValidationMapping}
                    icon={<CheckOutlined />}
                    size="small"
                    loading={loadingButton}
                  >
                    {t("General.Labels.Create", {
                      lngs: i18n.languages,
                      defaultValue: "Create",
                    })}
                  </Button>
                  <Popconfirm
                    style={{ width: "400px" }}
                    placement="topRight"
                    title={
                      <div
                        style={{
                          width: "400px",
                          wordBreak: "break-word",
                        }}
                      >
                        {t(
                          "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ConfirmClose",
                          {
                            lngs: i18n.languages,
                            defaultValue:
                              "Are you really sure that you want to close this drawer? All changes made will be lost.",
                          }
                        )}
                      </div>
                    }
                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                    visible={popConfirmOpen}
                    onVisibleChange={handleOpenPopConfirm}
                    onConfirm={() => onClose()}
                    okText={t("General.Actions.Yes", {
                      lngs: i18n.languages,
                      defaultValue: "Yes",
                    })}
                    cancelText={t("General.Actions.No", {
                      lngs: i18n.languages,
                      defaultValue: "No",
                    })}
                  >
                    <Button
                      type="ghost"
                      icon={<CloseOutlined />}
                      size="small"
                    />
                  </Popconfirm>
                </>
              )}
            </Space>
          }
        >
          <Form
            disabled={RowAction.View === drawerAction ? true : false}
            layout="vertical"
          >
            <div className="validation-mapping-drawer">
              <div className="validation-mapping-form-left">
                <Form.Item
                  label={LabelUtil.ensureColonAtEnd(t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.GroupCode",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Group code:",
                    }
                  ))}
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.GroupCode",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                  required={groupCodeMandatory}
                >
                  <Select
                    placeholder={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Inputs.GroupCode", {
                      lngs: i18n.languages,
                      defaultValue: "Select Group code or leave empty for logic to apply to all",
                    })}
                    allowClear
                    showSearch={true}
                    showArrow={true}
                    options={groupCodes.map((x: any) => ({
                      label: x.code,
                      value: x.code,
                    }))}
                    value={editedRow?.groupCode}
                    filterSort={(optionA, optionB) =>
                      optionA.value! < optionB.value! ? -1 : 1
                    }
                    onChange={onGroupCodeChange}
                    disabled={!editedRow?.editableGroupCode}
                  ></Select>
                </Form.Item>
                <Form.Item
                  label={LabelUtil.ensureColonAtEnd(t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.FromTable",
                    {
                      lngs: i18n.languages,
                      defaultValue: "From table",
                    }
                  ))}
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.FromTable",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                >
                  <Select
                    placeholder={t("General.Placeholders.SelectOption", {
                      lngs: i18n.languages,
                      defaultValue: "Select option",
                    })}
                    allowClear
                    showSearch={true}
                    showArrow={true}
                    value={editedRow?.fromTableId}
                    options={fromTables}
                    onChange={onSelectedFromTableChange}
                    filterOption={(inputValue: any, option: any) =>
                      option!.label
                        .toUpperCase()
                        .indexOf(
                          inputValue.toUpperCase()
                        ) !== -1
                    }
                  ></Select>
                </Form.Item>
                <Button onClick={() => { setTranslationModal(true) }} className="ant-btn-secondary">Add translation</Button>
                <Form.Item
                  label={LabelUtil.ensureColonAtEnd(t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.FromField",
                    {
                      lngs: i18n.languages,
                      defaultValue: "From field",
                    }
                  ))}
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.FromField",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                >
                  <AutoComplete
                    defaultActiveFirstOption={false}
                    placeholder={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Inputs.FromField", {
                      lngs: i18n.languages,
                      defaultValue: "Enter field or SQL statement",
                    })}
                    // allowClear
                    showSearch={true}
                    // showArrow={true}
                    value={editedRow?.fromValue.toString()}
                    defaultValue={""}
                    // options={editedRow?.fromFieldList}
                    onSelect={onAutoCompleteSelectedFromFieldChange}
                    filterSort={(optionA, optionB) =>
                      optionA.value! < optionB.value! ? -1 : 1
                    }
                    options={editedRow?.fromFieldList?.map((x: any) => ({
                      label: x.nameLabel,
                      value: x.label.toString(),
                    }))}
                    filterOption={(inputValue: any, option: any) =>
                      option!.value
                        .toUpperCase()
                        .indexOf(editedRow?.fromValue.toUpperCase()) !== -1
                    }
                  // value={entityInput}
                  // onChange={onEntityChange}
                  >

                    <TextArea
                      rows={4}
                      autoSize
                      allowClear
                      value={editedRow?.fromValue.toString()}
                      onChange={onAreaSelectedFromFieldChange}
                    />
                  </AutoComplete>
                </Form.Item>

                <Form.Item
                  label={LabelUtil.ensureColonAtEnd(t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Join",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Join",
                    }
                  ))}
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Join",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                >
                  <Input.TextArea
                    placeholder={
                      t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })!
                    }
                    allowClear
                    rows={4}
                    autoSize
                    value={editedRow?.join}
                    onChange={onSelectedJoinChange}
                  ></Input.TextArea>
                </Form.Item>

              </div>
              <div className="validation-mapping-form-right">
                <Form.Item
                  label={LabelUtil.ensureColonAtEnd(t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Sequence",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Sequence",
                    }
                  ))}
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Sequence",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                >
                  <InputNumber
                    placeholder={
                      t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })!
                    }
                    value={editedRow?.sequence}
                    onChange={onSelectedSequenceChange}
                  ></InputNumber>
                </Form.Item>
                <Form.Item
                  label={LabelUtil.ensureColonAtEnd(t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Comments",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Comments",
                    }
                  ))}
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Comments",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                >
                  <Input.TextArea
                    placeholder={
                      t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })!
                    }
                    allowClear
                    rows={9}
                    // autoSize
                    value={editedRow?.comments}
                    onChange={onSelectedCommentsChange}
                  ></Input.TextArea>
                </Form.Item>
              </div>
            </div>


          </Form>
        </Drawer>
      )}
      {openTestDrawer && (
        <Drawer
          height={"95vh"}
          width={"400px"}
          getContainer={false}
          style={{
            position: "absolute",
          }}
          title={t(
            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Testing",
            {
              lngs: i18n.languages,
              defaultValue: "Testing",
            }
          )}
          placement={DRAWER_PLACEMENTS.BOTTOM}
          onClose={onCloseTestDrawer}
          visible={openTestDrawer}
          closable={false}
          extra={
            <Space>
              <>
                <Button
                  icon={<ForwardOutlined />}
                  size="small"
                  onClick={() => runTest(false)}
                >
                  {t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ActionRun",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Run",
                    }
                  )}
                </Button>
                <Button
                  icon={<ForwardOutlined />}
                  size="small"
                  onClick={() => runTest(true)}
                >
                  {t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ActionGenerateSQLQuery",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Generate SQL Query",
                    }
                  )}
                </Button>
                <Button
                  onClick={onTestApplyChanges}
                  icon={<CheckOutlined />}
                  size="small"
                >
                  {t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ActionApplyChanges",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Apply changes",
                    }
                  )}
                </Button>
                <Button
                  type="ghost"
                  onClick={onCloseTestDrawer}
                  icon={<CloseOutlined />}
                  size="small"
                />
              </>
            </Space>
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <Form form={testForm} layout="inline" labelCol={{ span: 12 }}>
                <Form.Item
                  style={{ width: "300px" }}
                  label={LabelUtil.ensureColonAtEnd(t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.GroupCode",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Group code:",
                    }
                  ))}
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.GroupCode",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                >
                  <Select
                    placeholder={
                      t("General.Placeholders.SelectOption", {
                        lngs: i18n.languages,
                        defaultValue: "Select option",
                      })!
                    }
                    loading={groupCodes.length === 0}
                    onChange={onTestGroupCodeChange}
                    value={selectedTestGroupCode}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    options={groupCodes.map((x: any) => ({
                      label: x.code,
                      value: x.code,
                    }))}
                    filterSort={(optionA, optionB) =>
                      optionA.value! < optionB.value! ? -1 : 1
                    }
                  ></Select>
                </Form.Item>
                <Form.Item
                  style={{ width: "300px" }}
                  label={LabelUtil.ensureColonAtEnd(t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Environment",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Environment:",
                    }
                  ))}
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Environment",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                >
                  <Select
                    placeholder={
                      t("General.Placeholders.SelectOption", {
                        lngs: i18n.languages,
                        defaultValue: "Select option",
                      })!
                    }
                    loading={environment.length === 0}
                    onChange={onEnvironmentChange}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    value={selectedEnvironment}
                    options={environment.map((x: any) => ({
                      label: x.name,
                      value: x.name,
                    }))}
                    filterSort={(optionA, optionB) =>
                      optionA.value! < optionB.value! ? -1 : 1
                    }
                  ></Select>
                </Form.Item>
              </Form>
            </div>

            <Pagination
              size="small"
              total={testTableViewData.length}
              current={viewTablePageIndex}
              pageSize={viewTablePageSize}
              showQuickJumper={true}
              showSizeChanger={true}
              locale={{
                items_per_page: t("General.Table.Pagination.ItemPerPage", {
                  lngs: i18n.languages,
                  defaultValue: "/page",
                })!,
                page: t("General.Table.Pagination.Page", {
                  lngs: i18n.languages,
                  defaultValue: "page",
                })!,
                jump_to: t("General.Table.Pagination.GoTo", {
                  lngs: i18n.languages,
                  defaultValue: "Go to",
                })!,
              }}
              showTotal={(total: number, range: [number, number]) => {
                const translation = t("General.Table.Pagination.RangeRecords", {
                  lngs: i18n.languages,
                  defaultValue: `${range[0]}-${range[1]} out of ${total} records`,
                });
                return `${translation
                  .replace("${range[0]}", range[0].toString())
                  .replace("${range[1]}", range[1].toString())
                  .replace("${total}", total.toString())}`;
              }}
              itemRender={(page: number, type: any, originalElement: any) => {
                return originalElement;
              }}
              onChange={(page: any, size: any) => {
                setViewTablePageIndex(page);
                setViewTablePageSize(size);
              }}
            />
          </div>
          <Datatable
            scroll={false}
            tableColumns={testTableColumns}
            data={testTableViewData}
            setData={setTestTableViewData}
            isTableLoading={isTestTableLoading}
            otherActions={[]}
            otherRowEnabled={false}
            editRowEnabled={true}
            copyRowEnabled={true}
            deleteRowEnabled={true}
            onEditFunc={undefined}
            onCopyFunc={undefined}
            onDeleteFunc={false}
            onDoubleClickRow={undefined}
            selectable={false}
            multiSelect={false}
            selectedRows={undefined}
            setSelectedRows={undefined}
            paginationVisible={false}
            paginationPageIndex={viewTablePageIndex}
            paginationPageSize={viewTablePageSize}
            showActionsColumn={false}
            checkPermissions={true}
          ></Datatable>
          <Form layout="vertical" form={testForm}>
            <Form.Item
              name="fromValue"
              label={LabelUtil.ensureColonAtEnd(t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.FromField",
                {
                  lngs: i18n.languages,
                  defaultValue: "From Field:",
                }
              ))}
              tooltip={t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.FromField",
                {
                  lngs: i18n.languages,
                  defaultValue: "",
                }
              )}
            >
              <AutoComplete
                defaultActiveFirstOption={false}
                placeholder={t("General.Placeholders.EnterValue", {
                  lngs: i18n.languages,
                  defaultValue: "Enter value",
                })}
                // allowClear
                showSearch={true}
                // showArrow={true}
                value={testRow?.fromValue.toString()}
                defaultValue={""}
                // options={editedRow?.fromFieldList}
                onChange={onAutoCompleteSelectedTestFromFieldChange}
                filterSort={(optionA, optionB) =>
                  optionA.value! < optionB.value! ? -1 : 1
                }
                options={editedRow?.fromFieldList?.map((x: any) => ({
                  label: x.nameLabel,
                  value: x.label.toString(),
                }))}
                filterOption={(inputValue: any, option: any) =>
                  option!.value
                    .toUpperCase()
                    .indexOf(testRow?.fromValue.toUpperCase()) !== -1
                }
              // value={entityInput}
              // onChange={onEntityChange}
              >
                <TextArea
                  rows={4}
                  autoSize
                  allowClear
                  value={testRow?.fromValue.toString()}
                  onChange={onAreaSelectedTestFromFieldChange}
                />
              </AutoComplete>
            </Form.Item>
            <Form.Item
              name="customFields"
              label={LabelUtil.ensureColonAtEnd(t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.CustomFields",
                {
                  lngs: i18n.languages,
                  defaultValue: "Custom fields:",
                }
              ))}
              tooltip={t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.CustomFields",
                {
                  lngs: i18n.languages,
                  defaultValue: "",
                }
              )}
            >
              <Input.TextArea
                allowClear
                placeholder={
                  t("General.Placeholders.EnterValue", {
                    lngs: i18n.languages,
                    defaultValue: "Enter value",
                  })!
                }
                autoSize
                value={testRow?.customFields}
                onChange={onSelectedTestCustomFieldsChange}
              ></Input.TextArea>
            </Form.Item>
            <Form.Item
              name="join"
              label={LabelUtil.ensureColonAtEnd(t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Join",
                {
                  lngs: i18n.languages,
                  defaultValue: "Join:",
                }
              ))}
              tooltip={t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Join",
                {
                  lngs: i18n.languages,
                  defaultValue: "",
                }
              )}
            >
              <Input.TextArea
                placeholder={
                  t("General.Placeholders.EnterValue", {
                    lngs: i18n.languages,
                    defaultValue: "Enter value",
                  })!
                }
                allowClear
                rows={4}
                autoSize
                value={testRow?.join}
                onChange={onSelectedTestJoinChange}
                style={{ whiteSpace: "pre-wrap" }}
                wrap="hard"
              ></Input.TextArea>
            </Form.Item>
            <Form.Item
              name="where"
              label={LabelUtil.ensureColonAtEnd(t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Where",
                {
                  lngs: i18n.languages,
                  defaultValue: "Where:",
                }
              ))}
              tooltip={t(
                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Where",
                {
                  lngs: i18n.languages,
                  defaultValue: "",
                }
              )}
            >
              <Input.TextArea
                placeholder={
                  t("General.Placeholders.EnterValue", {
                    lngs: i18n.languages,
                    defaultValue: "Enter value",
                  })!
                }
                allowClear
                rows={4}
                autoSize
                value={testRow?.where}
                onChange={onSelectedTestWhereChange}
                style={{ whiteSpace: "pre-wrap" }}
                wrap="hard"
              ></Input.TextArea>
            </Form.Item>
          </Form>
          <Collapse bordered={false} defaultActiveKey={['1']}>
            <Panel
              header="SQL"
              key="1"
              extra={
                <Button
                  className={styles.copyButton}
                  onClick={(event) => {
                    navigator.clipboard.writeText(testRow.sqlCode);
                    event.stopPropagation();
                  }}
                  icon={<CopyOutlined></CopyOutlined>}
                ></Button>
              }
            >
              {/* {testRow?.sqlCode} */}
              {testRow?.sqlCode.split("\n").map((item: any) => (
                <>
                  {item}
                  <br />
                </>
              ))}
            </Panel>
          </Collapse>
        </Drawer>
      )}
      <Modal
        title={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap.Title", {
          lngs: i18n.languages,
          defaultValue: "Automap",
        })}
        okText={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap.Ok", {
          lngs: i18n.languages,
          defaultValue: "Ok",
        })}
        cancelText={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap.Cancel", {
          lngs: i18n.languages,
          defaultValue: "Cancel",
        })}
        visible={automapValidationMappingModalEnabled}
        onOk={onAutomapValidationMapping}
        onCancel={() => setAutomapValidationMappingModalEnabled(false)}>
        <Form
          layout="vertical"
        >
          <Form.Item
            label={LabelUtil.ensureColonAtEnd(t(
              "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.GroupCode",
              {
                lngs: i18n.languages,
                defaultValue: "Group code:",
              }
            ))}
            tooltip={t(
              "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.GroupCode",
              {
                lngs: i18n.languages,
                defaultValue: "",
              }
            )}
          >
            <Select
              placeholder={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Inputs.Automap.GroupCode", {
                lngs: i18n.languages,
                defaultValue: "Select Group code or leave empty for logic to apply to all",
              })}
              allowClear
              showSearch={true}
              showArrow={true}
              options={groupCodes.map((x: any) => ({
                label: x.code,
                value: x.code,
              }))}
              value={automapGroupCodeInput}
              filterSort={(optionA, optionB) =>
                optionA.value! < optionB.value! ? -1 : 1
              }
              onChange={onAutomapGroupCodeChange}
            ></Select>
          </Form.Item>
          <Form.Item
            label={LabelUtil.ensureColonAtEnd(t(
              "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Entity",
              {
                lngs: i18n.languages,
                defaultValue: "Entity:",
              }
            ))}
            tooltip={t(
              "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Entity",
              {
                lngs: i18n.languages,
                defaultValue: "",
              }
            )}
          >
            <Select
              placeholder={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Inputs.Automap.Entity", {
                lngs: i18n.languages,
                defaultValue: "Select Entity",
              })}
              allowClear
              showSearch={true}
              showArrow={true}
              options={entities.map((x: any) => ({
                label: x.name,
                value: x.id,
              }))}
              value={automapEntityInput}
              filterSort={(optionA, optionB) =>
                optionA.value! < optionB.value! ? -1 : 1
              }
              onChange={onAutomapEntityChange}
            ></Select>
          </Form.Item>
          <Form.Item
            label={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap.OverwriteExistingData", {
              lngs: i18n.languages,
              defaultValue: "Overwrite existing mappings?",
            })}
            tooltip={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Automap.OverwriteExistingData", {
              lngs: i18n.languages,
              defaultValue: "",
            })}
          >
            <Checkbox
              value={automapOverwriteExistingData}
              checked={automapOverwriteExistingData}
              onClick={() => setAutomapOverwriteExistingData(!automapOverwriteExistingData)}
            >
            </Checkbox>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Translation"
        okText={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap.Ok", {
          lngs: i18n.languages,
          defaultValue: "Ok",
        })}
        cancelText={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap.Cancel", {
          lngs: i18n.languages,
          defaultValue: "Cancel",
        })}
        visible={translationModal}
        onOk={translationModalOnOk}
        onCancel={() => { setTranslationModal(false) }}
      >
        <Form
          form={translationForm}
          layout="vertical"
        >
          <Form.Item name={"fromValue"} label={"From value:"} hidden={!translationModal}>
            <Select
              defaultActiveFirstOption={false}
              placeholder={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Inputs.FromField", {
                lngs: i18n.languages,
                defaultValue: "Enter field or SQL statement",
              })}
              showSearch={true}
              options={editedRow?.fromFieldList?.map((x: any) => ({
                label: x.label.toString(),
                value: x.label.toString(),
              }))}
              onChange={setFromValue}
              onSelect={setFromValue}
              value={fromValue}
              filterOption={(inputValue: any, option: any) =>
                  option!.label
                      .toUpperCase()
                      .indexOf(
                          inputValue.toUpperCase()
                      ) !== -1
              }
            />
          </Form.Item>
          <Form.Item name={"attribute"} label={"Attribute:"} hidden={!translationModal}>
            <Select
              options={
                attributes.map((x) => ({
                  label: x,
                  value: x
                }))
              }
              value={selectedAttribute}
              onChange={setSelectedAttribute}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ValidationMapping;
